import React, { useContext } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import mixpanel from 'mixpanel-browser';

import { AppContext } from './AppState';
import { DEFAULT_DAYS_SINCE, useMaterials } from '../utils/materialsLib';
import { useUploads } from '../utils/uploadsLib';
import { importLandingPage } from '../utils/business';

import ProcessingIcon from './ProcessingIcon';

const useStyles = makeStyles((theme) => ({
  tab: {
    display: 'inline-block',
    width: 'auto',
    position: 'relative',
  },
  selectorText: {
    cursor: 'pointer',
    color: '#aaa',
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(4),
    fontWeight: 'thick',
    letterSpacing: '-0.03em',
    '&:hover': {
      color: theme.palette.primary.light
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.4em',
      marginRight: theme.spacing(1.5),
    },
  },
  selectorTextFinal: {
    marginRight: theme.spacing(0),
  },
  currentLink: {
    color: `${theme.palette.primary.main} !important`,
    textDecoration: 'underline',
    textDecorationThickness: '15%',
    textUnderlineOffset: '50%',
  },
  flex: {
    display: 'flex',
  },
  processingIcon: {
    marginTop: theme.spacing(-0.75),
    [theme.breakpoints.up('xs')]: {
      marginLeft: theme.spacing(0.5),
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  decoratorText: {
    cursor: 'pointer',
    position: 'absolute',
    top: '-10px',
    left: '1px',
    margin: 0,
    color: theme.palette.primary.main,
    fontSize: '0.7em',
    fontWeight: 'bold',
  },
}));


export default function GalleryTabSelector(props) {
  const { current } = props;

  const { galleryUser, qaDisplay, importAvailable, setRedirect } = useContext(AppContext);

  const classes = useStyles();
  const classesThis = `${classes.selectorText} ${classes.currentLink}`;
  const classesOther = `${classes.selectorText}`;
  const classesThisFinal = `${classes.selectorText} ${classes.currentLink} ${classes.selectorTextFinal}`;
  const classesOtherFinal = `${classes.selectorText} ${classes.selectorTextFinal}`;

  // We reduce the number of API fetch calls by sharing the same cache key as useMaterials() on in status.js.
  const { processingMaterialsCount } = useMaterials(galleryUser, null, DEFAULT_DAYS_SINCE, true, qaDisplay, false, 60000);

  // We reduce the number of API fetch calls by sharing the same cache key as useUploads() on in status.js.
  const { uploadsPending } = useUploads(galleryUser, null, DEFAULT_DAYS_SINCE, true, 60000);

  const allowImport = qaDisplay ? true : importAvailable;  // Remains null if unset, e.g. while still loading

  async function clickImport(importAllowed) {
    if (importAllowed) {
      await navIfNotCurrent('/import');
    } else {
      mixpanel.track('View Landing Page', { page: 'import' });
      window.open(importLandingPage, '_blank');
    }
  }

  async function navIfNotCurrent(target) {
    if (!target.includes(current)) {
      setRedirect(target);
    }
  }

  return (
    <div className={classes.flex}>
      <Grid container>
        <Grid item className={classes.tab}>
          <Typography
            variant='h3'
            className={current == 'home' ? classesThis : classesOther}
            onClick={() => navIfNotCurrent('/home')}
          >
            Library
          </Typography>
        </Grid>
        <Grid item className={classes.tab}>
          <Typography
            variant='h3'
            className={current == 'upload' ? classesThis : classesOther}
            onClick={() => navIfNotCurrent('/upload')}
          >
            Scan
          </Typography>
        </Grid>
        <Grid item className={classes.tab}>
          <Typography
            variant='h3'
            className={current == 'import' ? classesThis : classesOther}
            onClick={() => clickImport(allowImport)}
          >
            Import
          </Typography>
          <Typography
            variant='caption'
            className={classes.decoratorText}
            onClick={() => clickImport(allowImport)}
          >
            {allowImport === true && 'NEW'}
            {allowImport === false && 'COMING SOON'}
          </Typography>
        </Grid>
        <Grid item className={classes.tab}>
          <Typography
            variant='h3'
            className={current == 'status' ? classesThisFinal : classesOtherFinal}
            onClick={() => navIfNotCurrent('/status')}
          >
            Processing
            {(processingMaterialsCount > 0 || uploadsPending > 0) && (
              <span className={classes.processingIcon}><ProcessingIcon /></span>
            )}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}
